import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ApiKey } from 'dashboard/models/api-key';
import { setApiKey } from 'dashboard/redux/slices/api-key';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export const loadApiKey = (id: string) => {
  return async (dispatch: Dispatch) => {
    const apiKeyResponse = await SessionClientDashboard.getResource<ApiKey>(ApiEndpoint.ApiKey, id);

    const apiKey = apiKeyResponse.data;

    dispatch(setApiKey(apiKey));
  };
};

export const updateApiKey = (
  id: string,
  attributes: Partial<ApiKey['attributes']>,
  meta: { 'password-confirmation': string },
) => {
  return async () => {
    const updateApiKeyResponse = await SessionClientDashboard.updateResource<ApiKey>(
      {
        type: ApiModel.ApiKey as const,
        id: id,
        attributes: {
          name: attributes['name'],
          note: attributes['note'],
          'api-version': attributes['api-version'],
          'api-key-inflection': attributes['api-key-inflection'],
          'api-attributes-blocklist': attributes['api-attributes-blocklist'],
          permissions: attributes['permissions'],
          'ip-address-allowlist': attributes['ip-address-allowlist'],
          'file-access-token-expires-in': attributes['file-access-token-expires-in'],
        },
      },
      {
        meta: {
          'password-confirmation': meta['password-confirmation'],
        },
      },
    );

    return updateApiKeyResponse;
  };
};

export const expireApiKey = (
  id: string,
  meta: { 'expires-in-seconds': string; 'password-confirmation': string },
) => {
  return async () => {
    const expireApiKeyResponse = await SessionClientDashboard.postResourceAction<ApiKey>(
      {
        type: ApiModel.ApiKey as const,
        id: id,
      },
      'expire',
      {
        meta: {
          'expires-in-seconds': meta['expires-in-seconds'],
          'password-confirmation': meta['password-confirmation'],
        },
      },
    );

    return expireApiKeyResponse;
  };
};
